module.exports = __webpack_public_path__ + "img/error.4b72ce65.jpg";